import { CheckpointQueueAccessType } from '../../../domain/models/CheckpointQueueAccessType';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { logError } from '../../../../shared/error/logError';

export function useAccessTypeName(accessType: CheckpointQueueAccessType) {
	const { t } = useTranslation();

	switch (accessType) {
		case CheckpointQueueAccessType.PreCheck:
			return t('security_filter_checkpoint_pre_check');

		case CheckpointQueueAccessType.Priority:
			return t('security_filter_checkpoint_priority');

		case CheckpointQueueAccessType.General:
			return t('security_filter_checkpoint_all_checkpoints');

		default:
			const invalidAccessType: never = accessType;

			const error = new Error(`Invalid access type: ${invalidAccessType}`);
			logError(error);

			return accessType;
	}
}
